import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import Pagination from '../pagination';
import { UserAction } from '../../store/actions';

class List extends PureComponent {
  static propTypes = {
    authHasOffice: PropTypes.bool,
    deleteUser: PropTypes.func,
    getUsers: PropTypes.func,
    location: PropTypes.object,
    permissions: PropTypes.arrayOf(PropTypes.string),
    users: PropTypes.object,
  };

  componentDidMount() {
    this.props.getUsers(
      Object.fromEntries(new URLSearchParams(this.props.location.search)),
    );
  }

  onDelete(row) {
    if (!confirm('Are you sure?')) {
      return;
    }
    this.props.deleteUser(row.id);
  }

  onSearch(event) {
    const {
      target: { value },
    } = event;
    this.props.getUsers({ query: value });
  }

  render() {
    const {
      authHasOffice = false,
      getUsers = () => {},
      location = {},
      permissions = [],
      users: { data: users = [], links = [] } = {},
    } = this.props;
    return (
      <div className="row">
        <div className="col">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">User</h3>
              <div className="card-tools d-print-none">
                <Pagination
                  getList={getUsers}
                  links={links}
                  location={location}
                />
              </div>
              <div className="card-tools d-print-none mr-2">
                <div
                  className="input-group input-group-sm"
                  style={{ width: '150px' }}
                >
                  <input
                    className="form-control"
                    onChange={this.onSearch.bind(this)}
                    placeholder="Search"
                    type="text"
                  />
                </div>
              </div>
              {permissions?.includes?.('user.create') && (
                <div className="card-tools d-print-none mr-2">
                  <div className="input-group input-group-sm">
                    <Link
                      className="btn btn-primary btn-sm"
                      to={`${this.props.match?.path}/create`}
                    >
                      <i className="fas fa-plus-square mr-1"></i>
                      Create
                    </Link>
                  </div>
                </div>
              )}
            </div>
            <div className="card-body p-0">
              {users?.length === 0 && (
                <p className="text-center my-2">No data found.</p>
              )}
              {users?.length > 0 && (
                <table className="table table-striped text-nowrap">
                  <thead>
                    <tr>
                      {permissions?.some?.(p =>
                        [
                          'user.change_password',
                          'user.delete',
                          'user.edit',
                        ]?.includes?.(p),
                      ) && (
                        <th
                          className="d-print-none"
                          style={{ minWidth: '175px' }}
                        >
                          Action
                        </th>
                      )}
                      {!authHasOffice && <th>Office</th>}
                      <th>ID</th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Role</th>
                    </tr>
                  </thead>
                  <tbody>
                    {users?.map?.(row => (
                      <tr key={row.id}>
                        {permissions?.some?.(p =>
                          [
                            'user.change_password',
                            'user.delete',
                            'user.edit',
                          ]?.includes?.(p),
                        ) && (
                          <td className="d-print-none">
                            <div className="btn-group">
                              {permissions?.includes?.('user.edit') && (
                                <Link
                                  className="align-items-center btn btn-info btn-sm d-inline-flex"
                                  to={`${this.props.match?.path}/${row.id}/edit`}
                                >
                                  <i className="fas fa-edit mr-1"></i>
                                  Edit
                                </Link>
                              )}
                              {permissions?.includes?.('user.delete') && (
                                <button
                                  className="btn btn-danger btn-sm"
                                  onClick={() => this.onDelete(row)}
                                  type="button"
                                >
                                  <i className="fas fa-trash mr-1"></i>
                                  Delete
                                </button>
                              )}
                              {permissions?.some?.(p =>
                                ['user.change_password']?.includes?.(p),
                              ) && (
                                <>
                                  <button
                                    className="btn btn-sm btn-success dropdown-toggle"
                                    data-boundary="window"
                                    data-toggle="dropdown"
                                    aria-expanded="false"
                                    type="button"
                                  />
                                  <div className="dropdown-menu" role="menu">
                                    {permissions?.includes?.(
                                      'user.change_password',
                                    ) && (
                                      <Link
                                        className="dropdown-item"
                                        to={`${this.props.match?.path}/${row.id}/change-password`}
                                      >
                                        <i className="fas fa-lock mr-1"></i>
                                        Change Password
                                      </Link>
                                    )}
                                  </div>
                                </>
                              )}
                            </div>
                          </td>
                        )}
                        {!authHasOffice && <td>{row.office?.name}</td>}
                        <td>{row.id}</td>
                        <td>{row.name}</td>
                        <td>{row.email}</td>
                        <td>{row.roles?.find?.(i => i)?.name}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  authHasOffice: !!state?.auth?.office,
  permissions: state?.auth?.permissions,
  users: state?.user?.list,
});

const mapDispatchToProps = dispatch => ({
  deleteUser: id => dispatch(UserAction.deleteUser(id)),
  getUsers: params => dispatch(UserAction.getUsers(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(List);
